import { CSSProperties } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  src: string;
  className?: string | undefined;
  style?: CSSProperties | undefined;
}

export const SongsheetSlide = ({ src, className, style }: Props) => {
  const { t } = useTranslation();
  return (
    <img
      className={className}
      style={style}
      src={src}
      alt={t("carousel.slide.songsheet")}
    />
  );
};
